<div class="container_filtri">
  <div class="filtri" *ngFor="let categoriaTipoFascicolo of listaFascicoliPerCategoria">
    <p>{{categoriaTipoFascicolo.categoria.label}}:</p>
    <ul>
      <ng-template ngFor let-tipoFascicolo [ngForOf]="categoriaTipoFascicolo.tipiFascicolo">
        <li ><a style="text-transform: uppercase;cursor: pointer;" (click)="setTipoFascicolo(tipoFascicolo)" >{{tipoFascicolo.label | titleAmianto}}</a></li>
      </ng-template>
    </ul>
  </div>
</div>
